const translations = {
  it: {
    // Navbar
    nav: {
      home: 'Home',
      about: 'Chi sono',
      experience: 'Esperienza',
      projects: 'Progetti',
      skills: 'Competenze',
      contact: 'Contatti',
    },

    // Hero
    hero: {
      greeting: 'Ciao, mi chiamo',
      title: 'Game Programmer & Unity Developer',
      description:
        "Programmo e sviluppo esperienze interattive capaci di intrattenere e soddisfare l'utente finale. Dai serious games alle applicazioni di gamification, trasformo idee in prodotti coinvolgenti.",
      btnProjects: 'I miei Progetti',
      btnContact: 'Contattami',
      scroll: 'Scroll',
    },

    // About
    about: {
      label: '// Chi sono',
      titleStart: 'About ',
      titleHighlight: 'Me',
      p1Start: 'Sono un ',
      p1Bold: 'Game Programmer',
      p1End:
        " con una forte passione per la tecnologia e lo sviluppo di videogiochi. Il mio obiettivo principale è programmare e sviluppare prodotti capaci di intrattenere e soddisfare l'utente finale.",
      p2Start: 'La mia esperienza spazia dallo sviluppo di ',
      p2Bold: 'serious games',
      p2End:
        " alla formazione, fino all'ingegneria dei sistemi. Ho lavorato con Unity3D per creare applicazioni di gamification in ambito medico, ho insegnato sviluppo di giochi come tutor, e oggi sviluppo applicazioni AR/VR in Unity per Digitalmens.",
      p3: 'Credo che il game development sia il punto di incontro perfetto tra creatività e problem solving tecnico, e mi impegno ogni giorno per migliorare le mie competenze e creare esperienze interattive coinvolgenti. Sono sempre attivo su progetti personali e ho collaborato con diversi colleghi allo sviluppo di giochi indipendenti.',
      highlights: {
        unity: { label: 'Unity Developer', desc: 'Serious games & gamification' },
        csharp: { label: 'C# Specialist', desc: 'Gameplay & systems programming' },
        apple: { label: 'Apple Academy', desc: 'Certificato professionale' },
        degree: { label: 'Ing. del Software', desc: 'Università Mercatorum' },
        tutor: { label: 'Tutor Unity3D', desc: 'Formazione e didattica' },
        fullstack: { label: 'Full Stack', desc: 'React, HTML5, CSS3, JS' },
      },
    },

    // Experience
    experience: {
      label: '// Percorso',
      titleStart: 'Esperienza & ',
      titleHighlight: 'Formazione',
      subtitle:
        'Il mio percorso professionale tra game development, formazione e ingegneria dei sistemi.',
      educationTitle: 'Formazione',
      jobs: [
        {
          role: 'Sviluppatore Unity C# — AR/VR',
          company: 'Digitalmens',
          location: 'Napoli',
          period: 'Mag 2026 — Presente',
          description:
            "Sviluppo applicazioni AR e VR in Unity e C# per dispositivi XR. Progettazione delle interazioni, ottimizzazione delle performance e adattamento dell'esperienza su diverse piattaforme AR e VR.",
          tags: ['Unity', 'C#', 'AR', 'VR', 'XR'],
        },
        {
          role: 'Technical Assurance Engineer',
          company: 'Aubay',
          location: 'Napoli',
          period: 'Lug 2025 — Mag 2026',
          description:
            'Monitoraggio e garanzia della performance, stabilità e qualità dei servizi di rete telecomunicazioni. Analisi degli incidenti, identificazione delle cause e coordinamento con team cross-funzionali. Validazione configurazioni, supporto ai deployment e implementazione di misure preventive per il rispetto degli SLA.',
          tags: ['Networking', 'QA', 'Monitoring', 'Telecomunicazioni', 'SLA'],
        },
        {
          role: 'Unity3D Gamification Developer',
          company: 'Mediserve',
          location: 'Napoli',
          period: 'Set 2022 — Lug 2025',
          description:
            'Progettazione e sviluppo di serious games in Unity3D per formazione medica, educazione del paziente e simulazioni cliniche. Applicazione di principi di gamification per trasformare concetti medici complessi in esperienze di apprendimento interattive. Collaborazione con professionisti sanitari per garantire accuratezza scientifica.',
          tags: ['Unity3D', 'C#', 'Gamification', 'Healthcare', 'UI/UX'],
        },
        {
          role: 'Unity3D Tutor',
          company: 'Kodland',
          location: 'Napoli',
          period: 'Dic 2024 — Mag 2025',
          description:
            'Erogazione di corsi online Unity3D per giovani studenti, insegnando fondamenti di game development, scripting C# e design interattivo. Guida degli studenti in progetti pratici dal concept al gioco giocabile.',
          tags: ['Teaching', 'Unity3D', 'C#', 'Mentoring'],
        },
        {
          role: 'Unity3D Tutor',
          company: 'Accademia della Programmazione',
          location: 'Napoli',
          period: 'Apr 2022 — Set 2022',
          description:
            'Insegnamento di corsi online in Unity3D e C#, coprendo fondamenti di game development, scripting, UI, fisica e animazione. Creazione di progetti pratici per aiutare gli studenti a costruire giochi reali.',
          tags: ['Teaching', 'Unity3D', 'C#', 'Game Design'],
        },
        {
          role: 'Software Engineer',
          company: 'Imbalplast S.R.L',
          location: 'Caserta',
          period: 'Dic 2020 — Ago 2021',
          description:
            "Raccolta, analisi e validazione dati per garantire accuratezza e affidabilità. Identificazione di inconsistenze, risoluzione di problemi sui dati e implementazione di azioni correttive. Supporto alle decisioni tramite reporting chiaro e ottimizzazione dei processi.",
          tags: ['Data Analysis', 'Reporting', 'Process Optimization'],
        },
      ],
      education: [
        {
          degree: 'Laurea Triennale in Ingegneria del Software',
          institution: 'Università Mercatorum',
          status: '2023 — Apr 2026',
          description:
            'Solide basi in programmazione, architetture software e ingegneria dei sistemi. Tesi focalizzata su networking multiplayer nei videogiochi, unendo competenze accademiche e passione per il game development.',
        },
        {
          degree: 'Apple Developer Academy',
          institution: 'Napoli',
          status: 'Set 2019 — Dic 2020',
          description:
            'Programma intensivo focalizzato su sviluppo app iOS e game development con Swift, SwiftUI e Unity. Progettazione di applicazioni user-centered con metodologie Agile e design thinking.',
        },
        {
          degree: 'C1 Advanced — Cambridge English',
          institution: 'Cambridge Assessment English',
          status: 'Completato',
          description:
            'Certificazione di competenza linguistica avanzata in inglese (livello C1 QCER).',
        },
      ],
    },

    // Projects
    projects: {
      label: '// Progetti',
      titleStart: 'I Miei ',
      titleHighlight: 'Progetti',
      subtitle: 'Una selezione dei miei lavori più significativi.',
      viewAll: 'Vedi tutti i progetti',
      viewProject: 'Vedi progetto',
      backToHome: 'Torna alla Home',
      keyFeaturesLabel: 'Funzionalità Chiave',
      techStackLabel: 'Tech Stack',
      showcaseLabel: 'Showcase',
      inDevelopment: 'In Sviluppo',
      items: [
        {
          id: 'pirate-deceit',
          title: 'Pirate Deceit',
          badge: 'inDevelopment',
          description:
            'Pirate Deceit è un gioco multiplayer in prima persona di deduzione sociale ambientato in un mondo piratesco. I giocatori sono divisi in due fazioni — Sopravvissuti e Traditori — e devono affrontare un ciclo di fasi diurne e notturne. Di giorno tutti esplorano liberamente, raccogliendo oggetti e stringendo alleanze. Di notte, i Traditori possono trasformarsi in creature mostruose per dare la caccia ai Sopravvissuti sotto il manto dell\'oscurità.',
          keyFeatures: [
            'Gameplay multiplayer asimmetrico — meccaniche basate sul ruolo con abilità uniche per i Traditori (trasformazione in mostro, velocità aumentata, attacchi artiglio)',
            'Sistema di round giorno/notte — loop di gioco strutturato (Esplorazione, Notte, Fine Round) con tensione crescente',
            'Sistema inventario e oggetti — hotbar a 4 slot con armi equipaggiabili, sincronizzato in rete',
            'Sistema di trasformazione — i Traditori possono cambiare forma tra umano e mostro, con visual, animazioni e statistiche distinte',
          ],
          techStack: ['Unity (URP)', 'PurrNet', 'Steamworks.NET', 'C#', 'ScriptableObjects'],
          image: '/media/pirate-deceit/1.png',
          showcase: [
            { type: 'image', src: '/media/pirate-deceit/1.png' },
            { type: 'image', src: '/media/pirate-deceit/2.png' },
            { type: 'image', src: '/media/pirate-deceit/3.png' },
          ],
        },
        {
          id: 'dantes-sinner-filter',
          title: "Dante's Sinner Filter",
          storeUrl: 'https://play.google.com/store/apps/details?id=com.RGBGuelphs.SinnerFilter',
          storeLabel: 'Provalo sul Play Store',
          description:
            "Un gioco 2D action-puzzle top-down ispirato all'Inferno di Dante Alighieri. I giocatori vestono i panni di Dante, navigando 33 livelli artigianali — uno per ogni Canto — dove devono superare e condannare i peccatori attirandoli nelle botole designate. Ciascuno degli 11+ tipi di nemici (Lussuriosi, Golosi, Violenti, Eretici, Maghi e altri) presenta comportamenti IA unici. Un sistema di combo a punteggio premia le catture successive rapide con moltiplicatori crescenti, culminando in rank dalla D alla S.",
          keyFeatures: [
            '33 livelli handcrafted — uno per Canto — con progressione a ondate gestita da un sistema wave-driven',
            '11+ tipi di nemici con IA custom basata su state machine (Animator-driven) e libreria UnityMovementAI per steering e pathfinding (fuga, inseguimento, pattuglia, idle)',
            'Sistema di scoring a combo con moltiplicatori crescenti e rank dalla D alla S',
            'Persistenza tramite sistema di salvataggio/caricamento basato su JSON per progressi, achievement e punteggi',
            'Enciclopedia in-game con 36+ voci sbloccabili e 16 achievement con condizioni stratificate',
            'Addressable Assets per caricamento dinamico, Unity Localization per supporto multilingua e Timeline per cutscene',
          ],
          techStack: ['Unity', 'C#', 'UnityMovementAI', 'Addressable Assets', 'Unity Localization', 'Timeline', 'JSON Save System', 'iOS', 'Android'],
          image: '/media/dantes-sinner-filter/1.png',
          showcase: [
            { type: 'image', src: '/media/dantes-sinner-filter/1.png' },
            { type: 'image', src: '/media/dantes-sinner-filter/2.png' },
            { type: 'image', src: '/media/dantes-sinner-filter/3.png' },
            { type: 'image', src: '/media/dantes-sinner-filter/4.png' },
            { type: 'image', src: '/media/dantes-sinner-filter/5.png' },
            { type: 'image', src: '/media/dantes-sinner-filter/6.png' },
            { type: 'image', src: '/media/dantes-sinner-filter/7.png' },
          ],
        },
        {
          id: 'clinical-maze',
          title: 'Clinical Maze',
          description:
            'Clinical Maze è una piattaforma di formazione medica gamificata costruita in Unity per Mediserve, progettata per trasformare l\'educazione clinica in un\'esperienza 3D coinvolgente. I giocatori navigano ambienti immersivi — grotte, isole fluttuanti e foreste fantasy — incontrando porte interattive a quiz che testano le loro conoscenze nelle discipline mediche.',
          keyFeatures: [
            '11 scenari di formazione medica distinti, ciascuno con banchi di domande configurabili e punteggio',
            'Pipeline di analytics per domanda per la valutazione dei risultati di apprendimento',
            'Shop in-game con economia a monete persistente',
            'Narrazione audio per accessibilità e architettura modulare con singleton manager persistenti tra le scene',
          ],
          techStack: ['Unity', 'C#', 'RESTful API', 'ScriptableObjects', 'TextMeshPro'],
          image: '/media/clinical-maze/1.png',
          showcase: [
            { type: 'image', src: '/media/clinical-maze/1.png' },
            { type: 'image', src: '/media/clinical-maze/2.png' },
            { type: 'image', src: '/media/clinical-maze/3.png' },
            { type: 'image', src: '/media/clinical-maze/4.png' },
            { type: 'image', src: '/media/clinical-maze/5.png' },
          ],
        },
        {
          id: 'davincis-trial',
          title: "DaVinci's Trial",
          description:
            "Un'esperienza educativa di trivia e minigiochi in cui i giocatori sono guidati da Leonardo da Vinci stesso attraverso un viaggio di conoscenza, logica e abilità. Destinato a un pubblico giovane, il gioco unisce educazione storica con gameplay coinvolgente attraverso 8+ minigiochi interattivi e 100+ domande trivia su biologia, geografia, invenzioni e la vita di Leonardo.",
          keyFeatures: [
            '44+ livelli strutturati con modalità infinita, alternando round trivia e minigiochi logici',
            '5 livelli di difficoltà con Leonardo che invecchia visivamente, colonna sonora che evolve e modificatori come la modalità "Bugia"',
            'Sistema di medaglie (oro/argento), 16 achievement sbloccabili ed economia a monete in-game',
            'Architettura dual-platform con scene e prefab separati per mobile (iOS/Android) e PC (Windows)',
          ],
          techStack: ['Unity', 'C#', 'LeanTween', 'LeanLocalization', 'Windows Speech Recognition', 'GestureRecognizer', 'Unity IAP & Ads', 'iOS', 'Android', 'Windows'],
          image: '/media/davincis-trial/1.png',
          showcase: [
            { type: 'image', src: '/media/davincis-trial/1.png' },
            { type: 'image', src: '/media/davincis-trial/2.png' },
            { type: 'image', src: '/media/davincis-trial/3.png' },
            { type: 'image', src: '/media/davincis-trial/4.png' },
            { type: 'image', src: '/media/davincis-trial/5.png' },
            { type: 'image', src: '/media/davincis-trial/6.png' },
            { type: 'image', src: '/media/davincis-trial/7.png' },
          ],
        },
        {
          id: 'squid-mcquick',
          title: 'Squid McQuick',
          description:
            'Un gioco 2D frenetico di gestione del tempo costruito in Unity, distribuito per WebGL. I giocatori gestiscono un food truck "fuori dai radar", destreggiarsi tra ordini multi-step di zuppa di noodle su stazioni di cottura parallele, gestendo ondate crescenti di clienti e schivando incontri con la polizia.',
          keyFeatures: [
            'Sistema a ondate con scaling di difficoltà dinamico su 4 ondate con ordini multi-ingrediente sempre più complessi',
            'Pipeline di cottura modulare con 3 slot piatto simultanei e assemblaggio ingredienti guidato da stati',
            'Meccanica di schivata della polizia che aggiunge tensione tra cucina e consapevolezza situazionale',
            'Sistema tutorial interattivo a 22 step con animazioni guidate e dialoghi typewriter',
          ],
          techStack: ['Unity', 'C#', 'WebGL', 'ScriptableObjects'],
          image: '/media/squid-mcquick/1.png',
          showcase: [
            { type: 'image', src: '/media/squid-mcquick/1.png' },
            { type: 'image', src: '/media/squid-mcquick/2.png' },
            { type: 'image', src: '/media/squid-mcquick/3.png' },
          ],
        },
        {
          id: 'dungeon-manager',
          title: 'Dungeon Manager 2.0',
          description:
            'Un gioco multiplayer asimmetrico competitivo costruito in Unity dove due giocatori assumono ruoli opposti: l\'Eroe, che deve combattere attraverso stanze del dungeon, e il Dungeon Manager, che progetta e popola le stanze con nemici, trappole e pericoli per fermarlo. L\'Eroe equipaggia armi ed equipaggiamento tramite un sistema di selezione a carte, mentre il Dungeon Manager piazza pericoli strategicamente.',
          keyFeatures: [
            'Gameplay asimmetrico competitivo con ruoli Eroe vs Dungeon Manager',
            'Sistema di selezione equipaggiamento basato su carte con armi, armature e modificatori a medaglione elementale',
            'Varietà di nemici: inseguitori corpo a corpo, maghi a distanza, kamikaze esplosivi, ladri di armi e draghi',
            'Multiplayer peer-to-peer con Netcode for GameObjects, Unity Relay e Lobby Services',
          ],
          techStack: ['Unity', 'C#', 'Netcode for GameObjects', 'Unity Relay & Lobby', 'Spine', 'LeanTween', 'TextMesh Pro', 'ScriptableObjects'],
          image: '/media/dungeon-manager/1.png',
          showcase: [
            { type: 'image', src: '/media/dungeon-manager/1.png' },
            { type: 'image', src: '/media/dungeon-manager/2.png' },
            { type: 'image', src: '/media/dungeon-manager/3.png' },
          ],
        },
        {
          id: 'hyperspells',
          title: 'Hyperspells',
          description:
            'Un gioco 3D hypercasual d\'azione dove i giocatori caricano attraverso ambienti fantasy, raccogliendo mana e monete mentre disegnano gesti magici sullo schermo per lanciare incantesimi devastanti contro ondate di nemici. Il core loop unisce un auto-runner con un sistema di spellcasting basato su gesture: cerchi, stelle, rune di fuoco e altro per scatenare palle di fuoco, fulmini e tornado.',
          keyFeatures: [
            'Sistema di spellcasting basato su gesture con riconoscimento di forme personalizzato',
            'Gestione del mana con selezione dinamica della difficoltà degli incantesimi',
            'Scontri con boss con meccanica di lancio cometa a tempo',
            'Sistema di ragdoll physics per le reazioni dei nemici e VFX per gli incantesimi',
          ],
          techStack: ['Unity (URP)', 'C#', 'Cinemachine', 'LeanTouch', 'LeanTween', 'GameAnalytics'],
          image: '/media/hyperspells/1.png',
          showcase: [
            { type: 'image', src: '/media/hyperspells/1.png' },
            { type: 'image', src: '/media/hyperspells/2.png' },
            { type: 'image', src: '/media/hyperspells/3.png' },
            { type: 'image', src: '/media/hyperspells/4.png' },
            { type: 'image', src: '/media/hyperspells/5.png' },
            { type: 'video', src: '/media/hyperspells/gameplay.mp4' },
          ],
        },
        {
          id: 'iwazaru',
          title: 'Iwazaru',
          description:
            'Un gioco puzzle cooperativo multiplayer costruito in Unity (2D) per 3 giocatori, ispirato al proverbio giapponese delle tre scimmie sagge — "Non vedere il male, Non sentire il male, Non parlare del male." Ogni giocatore assume il ruolo di una delle tre scimmie, ciascuna con una limitazione sensoriale unica, e la sfida principale è il coordinamento sotto informazioni asimmetriche.',
          keyFeatures: [
            'Gameplay cooperativo a 3 giocatori con limitazioni sensoriali asimmetriche (schermo nero, audio silenziato, niente chat vocale)',
            'Livelli puzzle basati su griglia con sequenze di pulsanti colorati tra zone diverse',
            'Chat vocale in tempo reale basata sulla prossimità con muting e deafening per giocatore',
          ],
          techStack: ['Unity', 'C#', 'Netcode for GameObjects', 'Unity Relay & Lobby', 'Dissonance Voice Chat', 'Cinemachine'],
          image: '/media/iwazaru/1.png',
          showcase: [
            { type: 'image', src: '/media/iwazaru/1.png' },
            { type: 'image', src: '/media/iwazaru/2.png' },
            { type: 'image', src: '/media/iwazaru/3.png' },
          ],
        },
        {
          id: 'lets-go-together',
          title: "Let's Go Together",
          itchUrl: 'https://giusmonph.itch.io/lets-go-together',
          itchLabel: 'Giocalo su Itch.io',
          description:
            'Un gioco 2D casual di gestione in cui guidi un gruppo di studenti per le strade di Milano, tenendoli concentrati e uniti nel tragitto verso la Milano Games Week. I giocatori si prendono cura di un gruppo di studenti — ciascuno con personalità, amicizie, rivalità e debolezze uniche — e devono trascinarli e riposizionarli su una griglia per impedire che si allontanino verso le distrazioni.',
          keyFeatures: [
            'Meccanica drag & swap su griglia basata su slot con personalità e archetipi degli studenti',
            'Sistema di distrazioni dinamiche (negozi di animali, sale giochi, bancarelle di cibo, musicisti di strada)',
            'Quiz collezionabili mid-run per punti bonus',
            'Tre livelli di difficoltà con voci enciclopedia e lore dei personaggi sbloccabili',
          ],
          techStack: ['Unity', 'C#', 'TextMesh Pro', 'LeanTween', 'Unity Timeline', 'ScriptableObjects'],
          image: '/media/lets-go-together/1.png',
          showcase: [
            { type: 'image', src: '/media/lets-go-together/1.png' },
            { type: 'image', src: '/media/lets-go-together/2.png' },
            { type: 'image', src: '/media/lets-go-together/3.png' },
            { type: 'image', src: '/media/lets-go-together/4.png' },
            { type: 'image', src: '/media/lets-go-together/5.png' },
            { type: 'image', src: '/media/lets-go-together/6.png' },
          ],
        },
        {
          id: 'rush',
          title: 'Rush — Online Party Game',
          description:
            'Un gioco di carte party multiplayer online costruito in Unity dove i giocatori competono in round veloci a tema di abbinamento carte. I giocatori si connettono tramite lobby Steam e giocano in tempo reale con architettura server-authoritative. Tre modalità tematiche (Medievale, Sci-Fi, Pulisci la Stanza) con meccaniche di carte uniche.',
          keyFeatures: [
            'Tre modalità di gioco tematiche: Medievale (fantasy), Sci-Fi (con meccanica del Traditore), e Pulisci la Stanza',
            'Tipi di carte unici con effetti speciali: scarti, respawn e generazione di nuove carte',
            'Multiplayer server-authoritative con Mirror Networking',
            'Integrazione Steam per lobby, matchmaking e identità giocatore tramite Steamworks.NET',
          ],
          techStack: ['Unity', 'C#', 'Mirror Networking', 'Steamworks.NET', 'FizzySteamworks', 'LeanTween', 'TextMeshPro', 'ScriptableObjects'],
          image: '/media/rush/1.png',
          showcase: [
            { type: 'image', src: '/media/rush/1.png' },
            { type: 'image', src: '/media/rush/2.png' },
            { type: 'image', src: '/media/rush/3.png' },
            { type: 'image', src: '/media/rush/4.png' },
            { type: 'image', src: '/media/rush/5.png' },
            { type: 'image', src: '/media/rush/6.png' },
          ],
        },
      ],
    },

    // Skills
    skills: {
      label: '// Competenze',
      titleStart: 'Tech ',
      titleHighlight: 'Stack',
      subtitle: 'Le tecnologie e gli strumenti che utilizzo quotidianamente.',
    },

    // Contact
    contact: {
      label: '// Contatti',
      titleStart: "Let's ",
      titleHighlight: 'Connect',
      subtitle:
        'Hai un progetto in mente o vuoi semplicemente fare una chiacchierata? Non esitare a contattarmi.',
      followMe: 'Seguimi su',
      ctaTitle: 'Pronto a collaborare?',
      ctaDesc:
        "Che si tratti di un progetto di game development, una collaborazione creativa o un'opportunità lavorativa, sono sempre aperto a nuove sfide.",
      ctaBtn: "Scrivimi un'email",
    },

    // Footer
    footer: {
      copy: 'Designed & Built by Giuseppe Monfregola',
    },
  },

  en: {
    // Navbar
    nav: {
      home: 'Home',
      about: 'About',
      experience: 'Experience',
      projects: 'Projects',
      skills: 'Skills',
      contact: 'Contact',
    },

    // Hero
    hero: {
      greeting: "Hi, I'm",
      title: 'Game Programmer & Unity Developer',
      description:
        'I develop interactive experiences that entertain and satisfy the end user. From serious games to gamification applications, I turn ideas into engaging products.',
      btnProjects: 'My Projects',
      btnContact: 'Get in Touch',
      scroll: 'Scroll',
    },

    // About
    about: {
      label: '// About me',
      titleStart: 'About ',
      titleHighlight: 'Me',
      p1Start: "I'm a ",
      p1Bold: 'Game Programmer',
      p1End:
        ' with a strong passion for technology and video game development. My main goal is to code and develop products that entertain and satisfy the end user.',
      p2Start: 'My experience spans from ',
      p2Bold: 'serious games',
      p2End:
        ' development to education and systems engineering. I have worked with Unity3D to create gamification apps in the medical field, taught game development as a tutor, and currently build AR/VR applications in Unity at Digitalmens.',
      p3: 'I believe game development is the perfect intersection of creativity and technical problem solving, and I strive every day to improve my skills and create engaging interactive experiences. I am always active on personal projects and have collaborated with multiple colleagues on independent game development.',
      highlights: {
        unity: { label: 'Unity Developer', desc: 'Serious games & gamification' },
        csharp: { label: 'C# Specialist', desc: 'Gameplay & systems programming' },
        apple: { label: 'Apple Academy', desc: 'Professional certificate' },
        degree: { label: 'Software Eng.', desc: 'Università Mercatorum' },
        tutor: { label: 'Unity3D Tutor', desc: 'Teaching & mentoring' },
        fullstack: { label: 'Full Stack', desc: 'React, HTML5, CSS3, JS' },
      },
    },

    // Experience
    experience: {
      label: '// Career',
      titleStart: 'Experience & ',
      titleHighlight: 'Education',
      subtitle:
        'My professional journey through game development, education and systems engineering.',
      educationTitle: 'Education',
      jobs: [
        {
          role: 'Unity C# Developer — AR/VR',
          company: 'Digitalmens',
          location: 'Naples',
          period: 'May 2026 — Present',
          description:
            'Building AR and VR applications in Unity and C# for XR devices. Day-to-day work covers interaction design, performance tuning, and adapting the experience across different AR and VR platforms.',
          tags: ['Unity', 'C#', 'AR', 'VR', 'XR'],
        },
        {
          role: 'Technical Assurance Engineer',
          company: 'Aubay',
          location: 'Naples',
          period: 'Jul 2025 — May 2026',
          description:
            'Monitoring and ensuring performance, stability, and quality of telecom network services. Analyzing incidents, identifying root causes, and coordinating with cross-functional teams. Validating system configurations, supporting service deployments, and implementing preventive measures to meet SLA targets.',
          tags: ['Networking', 'QA', 'Monitoring', 'Telecom', 'SLA'],
        },
        {
          role: 'Unity3D Gamification Developer',
          company: 'Mediserve',
          location: 'Naples',
          period: 'Sept 2022 — Jul 2025',
          description:
            'Designed and developed serious games in Unity3D for medical training, patient education, and clinical simulations. Applied gamification principles to transform complex medical concepts into interactive learning experiences. Collaborated with healthcare professionals to ensure scientific accuracy.',
          tags: ['Unity3D', 'C#', 'Gamification', 'Healthcare', 'UI/UX'],
        },
        {
          role: 'Unity3D Tutor',
          company: 'Kodland',
          location: 'Naples',
          period: 'Dec 2024 — May 2025',
          description:
            'Delivered online Unity3D courses to young learners, teaching game development fundamentals, C# scripting, and interactive design. Guided students through hands-on projects from concept to playable game.',
          tags: ['Teaching', 'Unity3D', 'C#', 'Mentoring'],
        },
        {
          role: 'Unity3D Tutor',
          company: 'Accademia della Programmazione',
          location: 'Naples',
          period: 'Apr 2022 — Sept 2022',
          description:
            'Taught online courses in Unity3D and C#, covering game development fundamentals, scripting, UI, physics, and animation. Created practical projects to help students build real games.',
          tags: ['Teaching', 'Unity3D', 'C#', 'Game Design'],
        },
        {
          role: 'Software Engineer',
          company: 'Imbalplast S.R.L',
          location: 'Caserta',
          period: 'Dec 2020 — Aug 2021',
          description:
            'Data collection, analysis, and validation to ensure accuracy and reliability. Identified inconsistencies, resolved data issues, and implemented corrective actions. Supported decision-making through clear reporting and applied analytical skills to improve processes.',
          tags: ['Data Analysis', 'Reporting', 'Process Optimization'],
        },
      ],
      education: [
        {
          degree: "Bachelor's Degree in Software Engineering",
          institution: 'Università Mercatorum',
          status: '2023 — Apr 2026',
          description:
            'Strong foundation in programming, software architecture, and systems engineering. Thesis focused on multiplayer networking in video games, bridging academic expertise with a passion for game development.',
        },
        {
          degree: 'Apple Developer Academy',
          institution: 'Naples',
          status: 'Sept 2019 — Dec 2020',
          description:
            'Intensive program focused on iOS app and game development using Swift, SwiftUI, and Unity. Designed user-centered applications applying Agile methodologies and design thinking.',
        },
        {
          degree: 'C1 Advanced — Cambridge English',
          institution: 'Cambridge Assessment English',
          status: 'Completed',
          description:
            'Advanced English language proficiency certification (CEFR level C1).',
        },
      ],
    },

    // Projects
    projects: {
      label: '// Projects',
      titleStart: 'My ',
      titleHighlight: 'Projects',
      subtitle: 'A selection of my most significant work.',
      viewAll: 'View all projects',
      viewProject: 'View project',
      backToHome: 'Back to Home',
      keyFeaturesLabel: 'Key Features',
      techStackLabel: 'Tech Stack',
      showcaseLabel: 'Showcase',
      inDevelopment: 'In Development',
      items: [
        {
          id: 'pirate-deceit',
          title: 'Pirate Deceit',
          badge: 'inDevelopment',
          description:
            'Pirate Deceit is a first-person multiplayer social deduction game set in a pirate-themed world. Players are split into two factions — Survivors and Traitors — and must navigate a cycle of day and night phases. During the day, everyone explores freely, gathering items and building alliances. When night falls, Traitors can transform into monstrous creatures to hunt down Survivors under the cover of darkness.',
          keyFeatures: [
            'Asymmetric multiplayer gameplay — role-based mechanics where Traitors gain unique abilities (monster transformation, enhanced speed, powerful claw attacks)',
            'Day/night round system — a structured game loop (Explore, Night, Round End) that creates escalating tension across multiple rounds',
            'Inventory & item system — a 4-slot hotbar with equippable weapons and pickups, fully synchronized across the network',
            'Transformation system — Traitors can shift between human and monster forms, each with distinct visuals, animations, stats, and attack behaviours',
          ],
          techStack: ['Unity (URP)', 'PurrNet', 'Steamworks.NET', 'C#', 'ScriptableObjects'],
          image: '/media/pirate-deceit/1.png',
          showcase: [
            { type: 'image', src: '/media/pirate-deceit/1.png' },
            { type: 'image', src: '/media/pirate-deceit/2.png' },
            { type: 'image', src: '/media/pirate-deceit/3.png' },
          ],
        },
        {
          id: 'dantes-sinner-filter',
          title: "Dante's Sinner Filter",
          storeUrl: 'https://play.google.com/store/apps/details?id=com.RGBGuelphs.SinnerFilter',
          storeLabel: 'Try it on Play Store',
          description:
            "A 2D top-down action-puzzle game inspired by Dante Alighieri's Inferno. Players take on the role of Dante, navigating 33 handcrafted levels — one for each Canto — where they must outwit and condemn sinners by luring them into their designated trapdoors. Each of the 11+ enemy types (Lustful, Gluttonous, Violent, Heretics, Mages, and more) features unique AI behaviors. A combo-based scoring system rewards quick successive captures with escalating multipliers, culminating in ranks from D through S.",
          keyFeatures: [
            '33 handcrafted levels — one per Canto — with wave-driven progression system',
            '11+ enemy types with custom AI state machines (Animator-driven) and UnityMovementAI library for steering & pathfinding (flee, chase, patrol, idle)',
            'Combo-based scoring system with escalating multipliers and ranks from D through S',
            'JSON-based save/load system for persistent progress, achievements, and high scores',
            'In-game encyclopedia with 36+ unlockable sinner entries and 16 achievements with layered conditions',
            'Addressable Assets for dynamic content loading, Unity Localization for multi-language support, and Timeline for cutscenes',
          ],
          techStack: ['Unity', 'C#', 'UnityMovementAI', 'Addressable Assets', 'Unity Localization', 'Timeline', 'JSON Save System', 'iOS', 'Android'],
          image: '/media/dantes-sinner-filter/1.png',
          showcase: [
            { type: 'image', src: '/media/dantes-sinner-filter/1.png' },
            { type: 'image', src: '/media/dantes-sinner-filter/2.png' },
            { type: 'image', src: '/media/dantes-sinner-filter/3.png' },
            { type: 'image', src: '/media/dantes-sinner-filter/4.png' },
            { type: 'image', src: '/media/dantes-sinner-filter/5.png' },
            { type: 'image', src: '/media/dantes-sinner-filter/6.png' },
            { type: 'image', src: '/media/dantes-sinner-filter/7.png' },
          ],
        },
        {
          id: 'clinical-maze',
          title: 'Clinical Maze',
          description:
            'A gamified medical training platform built in Unity for Mediserve, designed to transform clinical education into an engaging 3D experience. Players navigate immersive environments — caves, floating islands, and fantasy forests — while encountering interactive question gates that test their knowledge across medical disciplines.',
          keyFeatures: [
            '11 distinct medical training scenarios, each with configurable question banks and scoring',
            'Per-question analytics pipeline for learning outcome assessment',
            'In-game shop with persistent coin economy',
            'Audio narration for accessibility and modular architecture using singleton managers persisted across scenes',
          ],
          techStack: ['Unity', 'C#', 'RESTful API', 'ScriptableObjects', 'TextMeshPro'],
          image: '/media/clinical-maze/1.png',
          showcase: [
            { type: 'image', src: '/media/clinical-maze/1.png' },
            { type: 'image', src: '/media/clinical-maze/2.png' },
            { type: 'image', src: '/media/clinical-maze/3.png' },
            { type: 'image', src: '/media/clinical-maze/4.png' },
            { type: 'image', src: '/media/clinical-maze/5.png' },
          ],
        },
        {
          id: 'davincis-trial',
          title: "DaVinci's Trial",
          description:
            'An educational trivia and minigame experience where players are guided by Leonardo da Vinci himself through a journey of knowledge, logic, and skill. Targeted at younger audiences, the game blends historical education with engaging gameplay across 8+ interactive minigames and 100+ trivia questions spanning subjects like biology, geography, inventions, and Leonardo\'s own life.',
          keyFeatures: [
            '44+ structured levels with endless mode, alternating between trivia rounds and logic-based minigames',
            '5 difficulty tiers with Leonardo aging visually, evolving soundtrack, and modifiers like answer-inverting "Lie" mode',
            'Medal system (gold/silver), 16 unlockable achievements, and coin-based in-game economy',
            'Dual-platform architecture with separate scenes and prefabs for mobile (iOS/Android) and PC (Windows)',
          ],
          techStack: ['Unity', 'C#', 'LeanTween', 'LeanLocalization', 'Windows Speech Recognition', 'GestureRecognizer', 'Unity IAP & Ads', 'iOS', 'Android', 'Windows'],
          image: '/media/davincis-trial/1.png',
          showcase: [
            { type: 'image', src: '/media/davincis-trial/1.png' },
            { type: 'image', src: '/media/davincis-trial/2.png' },
            { type: 'image', src: '/media/davincis-trial/3.png' },
            { type: 'image', src: '/media/davincis-trial/4.png' },
            { type: 'image', src: '/media/davincis-trial/5.png' },
            { type: 'image', src: '/media/davincis-trial/6.png' },
            { type: 'image', src: '/media/davincis-trial/7.png' },
          ],
        },
        {
          id: 'squid-mcquick',
          title: 'Squid McQuick',
          description:
            'A fast-paced 2D time-management game built in Unity, deployed for WebGL. Players run an "off-the-books" food truck, juggling multi-step noodle soup orders across parallel cooking stations while managing escalating customer waves and dodging police encounters.',
          keyFeatures: [
            'Wave-based customer queue system with dynamic difficulty scaling across 4 waves with increasingly complex multi-ingredient orders',
            'Modular cooking pipeline with 3 simultaneous dish slots and state-driven ingredient assembly',
            'Police dodge mechanic that adds tension between cooking and situational awareness',
            '22-step interactive tutorial system with guided animations and typewriter dialogue',
          ],
          techStack: ['Unity', 'C#', 'WebGL', 'ScriptableObjects'],
          image: '/media/squid-mcquick/1.png',
          showcase: [
            { type: 'image', src: '/media/squid-mcquick/1.png' },
            { type: 'image', src: '/media/squid-mcquick/2.png' },
            { type: 'image', src: '/media/squid-mcquick/3.png' },
          ],
        },
        {
          id: 'dungeon-manager',
          title: 'Dungeon Manager 2.0',
          description:
            'A competitive asymmetric multiplayer game built in Unity where two players take on opposing roles: the Hero, who must fight through a series of dungeon rooms, and the Dungeon Manager, who designs and populates those rooms with enemies, traps, and hazards to stop them. The Hero picks equipment from a card-based selection system while the Dungeon Manager strategically places dangers.',
          keyFeatures: [
            'Competitive asymmetric gameplay with Hero vs Dungeon Manager roles',
            'Card-based equipment selection system with weapons, armor, and elemental medallion modifiers',
            'Enemy variety: melee chasers, ranged wizards, explosive kamikazes, weapon-stealing thieves, and dragons',
            'Peer-to-peer multiplayer with Netcode for GameObjects, Unity Relay & Lobby Services',
          ],
          techStack: ['Unity', 'C#', 'Netcode for GameObjects', 'Unity Relay & Lobby', 'Spine', 'LeanTween', 'TextMesh Pro', 'ScriptableObjects'],
          image: '/media/dungeon-manager/1.png',
          showcase: [
            { type: 'image', src: '/media/dungeon-manager/1.png' },
            { type: 'image', src: '/media/dungeon-manager/2.png' },
            { type: 'image', src: '/media/dungeon-manager/3.png' },
          ],
        },
        {
          id: 'hyperspells',
          title: 'Hyperspells',
          description:
            'A 3D hypercasual action game where players charge through fantasy environments, collecting mana and coins while drawing magical gestures on screen to cast devastating spells against waves of enemies. The core loop blends an auto-runner with a gesture-based spellcasting system: circles, stars, fire runes, and more to unleash fireballs, lightning strikes, and tornados.',
          keyFeatures: [
            'Gesture-based spellcasting system with custom shape recognition',
            'Mana management with dynamic spell difficulty selection',
            'Boss encounters with timed comet-casting mechanic',
            'Ragdoll physics system for enemy reactions and spell VFX',
          ],
          techStack: ['Unity (URP)', 'C#', 'Cinemachine', 'LeanTouch', 'LeanTween', 'GameAnalytics'],
          image: '/media/hyperspells/1.png',
          showcase: [
            { type: 'image', src: '/media/hyperspells/1.png' },
            { type: 'image', src: '/media/hyperspells/2.png' },
            { type: 'image', src: '/media/hyperspells/3.png' },
            { type: 'image', src: '/media/hyperspells/4.png' },
            { type: 'image', src: '/media/hyperspells/5.png' },
            { type: 'video', src: '/media/hyperspells/gameplay.mp4' },
          ],
        },
        {
          id: 'iwazaru',
          title: 'Iwazaru',
          description:
            'A cooperative multiplayer puzzle game built in Unity (2D) for exactly 3 players, inspired by the Japanese proverb of the three wise monkeys — "See no evil, Hear no evil, Speak no evil." Each player takes on the role of one of the three monkeys, each with a unique sensory limitation, and the core challenge is coordination under asymmetric information.',
          keyFeatures: [
            '3-player cooperative gameplay with asymmetric sensory limitations (blacked-out screen, silenced audio, no voice chat)',
            'Grid-based puzzle levels with colored button sequences across zones',
            'Real-time proximity-based voice communication with per-player muting and deafening',
          ],
          techStack: ['Unity', 'C#', 'Netcode for GameObjects', 'Unity Relay & Lobby', 'Dissonance Voice Chat', 'Cinemachine'],
          image: '/media/iwazaru/1.png',
          showcase: [
            { type: 'image', src: '/media/iwazaru/1.png' },
            { type: 'image', src: '/media/iwazaru/2.png' },
            { type: 'image', src: '/media/iwazaru/3.png' },
          ],
        },
        {
          id: 'lets-go-together',
          title: "Let's Go Together",
          itchUrl: 'https://giusmonph.itch.io/lets-go-together',
          itchLabel: 'Play it on Itch.io',
          description:
            'A 2D casual management game where you shepherd a group of students through the streets of Milan, keeping them focused and together on their way to Milano Games Week. Players take charge of students — each with unique personalities, friendships, rivalries, and weaknesses — and must drag and rearrange them on a grid to prevent them from wandering off toward distractions.',
          keyFeatures: [
            'Slot-based grid drag & swap mechanic with student personalities and archetypes',
            'Dynamic distraction system (pet shops, arcades, food stands, street musicians)',
            'Collectible mid-run quiz questions for bonus points',
            'Three difficulty levels with unlockable encyclopedia entries and character lore',
          ],
          techStack: ['Unity', 'C#', 'TextMesh Pro', 'LeanTween', 'Unity Timeline', 'ScriptableObjects'],
          image: '/media/lets-go-together/1.png',
          showcase: [
            { type: 'image', src: '/media/lets-go-together/1.png' },
            { type: 'image', src: '/media/lets-go-together/2.png' },
            { type: 'image', src: '/media/lets-go-together/3.png' },
            { type: 'image', src: '/media/lets-go-together/4.png' },
            { type: 'image', src: '/media/lets-go-together/5.png' },
            { type: 'image', src: '/media/lets-go-together/6.png' },
          ],
        },
        {
          id: 'rush',
          title: 'Rush — Online Party Game',
          description:
            'An online multiplayer party card game built in Unity where players compete in fast-paced, themed card-matching rounds. Players connect through Steam lobbies and play in real time using a server-authoritative architecture. Three themed game modes (Medieval, Sci-Fi, Clean the Room) with unique card mechanics.',
          keyFeatures: [
            'Three themed game modes: Medieval (fantasy), Sci-Fi (with Traitor mechanic), and Clean the Room',
            'Unique card types with special effects: discards, respawns, and card generation',
            'Server-authoritative multiplayer with Mirror Networking',
            'Steam integration for lobbies, matchmaking, and player identity via Steamworks.NET',
          ],
          techStack: ['Unity', 'C#', 'Mirror Networking', 'Steamworks.NET', 'FizzySteamworks', 'LeanTween', 'TextMeshPro', 'ScriptableObjects'],
          image: '/media/rush/1.png',
          showcase: [
            { type: 'image', src: '/media/rush/1.png' },
            { type: 'image', src: '/media/rush/2.png' },
            { type: 'image', src: '/media/rush/3.png' },
            { type: 'image', src: '/media/rush/4.png' },
            { type: 'image', src: '/media/rush/5.png' },
            { type: 'image', src: '/media/rush/6.png' },
          ],
        },
      ],
    },

    // Skills
    skills: {
      label: '// Skills',
      titleStart: 'Tech ',
      titleHighlight: 'Stack',
      subtitle: 'The technologies and tools I use on a daily basis.',
    },

    // Contact
    contact: {
      label: '// Contact',
      titleStart: "Let's ",
      titleHighlight: 'Connect',
      subtitle:
        "Have a project in mind or just want to chat? Don't hesitate to reach out.",
      followMe: 'Follow me on',
      ctaTitle: 'Ready to collaborate?',
      ctaDesc:
        "Whether it's a game development project, a creative collaboration or a job opportunity, I'm always open to new challenges.",
      ctaBtn: 'Send me an email',
    },

    // Footer
    footer: {
      copy: 'Designed & Built by Giuseppe Monfregola',
    },
  },
};

export default translations;
